import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Footer } from './Footer.js';
import { Header } from './Header.js';

/**
 * Moves focus and scroll to the top of the new page on navigation, which a
 * client-side router does not do on its own.
 */
function useRouteChangeFocus() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
    document.getElementById('main-content')?.focus({ preventScroll: true });
  }, [location.pathname, location.hash]);
}

export function PublicLayout() {
  useRouteChangeFocus();

  return (
    <div className="flex min-h-full flex-col">
      <a
        href="#main-content"
        className="sr-only rounded-br-lg bg-primary px-4 py-3 text-sm text-white focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-50"
      >
        Skip to main content
      </a>
      <Header />
      <main id="main-content" tabIndex={-1} className="flex-1 focus-visible:outline-none">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
